// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fm","advertDetailHeaderPrice__value":"c-m_fn","advertDetailHeaderPrice__label":"c-m_fo"};